export default __webpack_public_path__ + "static/media/160x90.a57d0fa7.jpg";